const internationalSampleCsvData = [
  {
    type: 'PERSONAL',
    countryCode: 'US',
    accountDetailsType: 'ACCOUNT_ID',
    accountDetailsValue: '183847823',
    bankIdentifierType: 'CLEARING_ID',
    bankIdentifierValue: '123456789',
    givenName: 'John',
    surname: 'Doe',
  },
  {
    type: 'BUSINESS',
    countryCode: 'GB',
    accountDetailsType: 'ACCOUNT_ID',
    accountDetailsValue: '12345678',
    bankIdentifierType: 'CLEARING_ID',
    bankIdentifierValue: '112233',
    fullName: 'Acme Corp',
  },
  {
    type: 'PERSONAL',
    countryCode: 'PK',
    accountDetailsType: 'IBAN',
    accountDetailsValue: 'PK35HABB0001111222212345',
    bankIdentifierType: 'BIC',
    bankIdentifierValue: 'HABBPKKA',
    fullName: 'KAMALA KHAN',
  },
];

const internationalSampleCsvFile = {
  fileName: 'international-verification-bulk-upload.csv',
  sampleCsvData: internationalSampleCsvData,
};

export { internationalSampleCsvFile };
